'use strict';

import animations from 'tc-neos-animations';

const init = () => {
    animations.init();
}

const scrollToTop = () => {
    animations.scrollToTop();
}

export default {init, scrollToTop}
